import React, { ComponentProps } from 'react';

import { BlockType } from '../../types/api/ElementType';
import { CategoriesDefaultView, CategoriesDefaultViewProps } from './views/CategoriesDefaultView';

import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { CategoriesEditView, CategoriesEditViewProps } from './views/CategoriesEditView';

type PageTypeCategoriesBlockProps = Views<DefaultView<CategoriesDefaultViewProps> & EditView<CategoriesEditViewProps>>;

function PageTypeCategories({ views, activeView = 'default' }: PageTypeCategoriesBlockProps) {
  switch (activeView) {
    case 'edit':
      return <CategoriesEditView {...views.edit} />;
    default:
      return <CategoriesDefaultView {...views.default} />;
  }
}

export const PageTypeCategoriesBlock = asFetchableBlock(PageTypeCategories, BlockType.pagetypecategories);
export type PageTypeCategoriesBlock = ComponentProps<typeof PageTypeCategoriesBlock>;
export const AnnouncementCategoriesBlock = asFetchableBlock(PageTypeCategories, BlockType.announcementcategories);
export type AnnouncementCategoriesBlock = ComponentProps<typeof AnnouncementCategoriesBlock>;
